import npAPI from "@/api/admin/numberpool";
import moment from "moment";

const state = () => ({
  newTask: {},
  newTaskLoading: false,
  pollTasksLoading: false,
  tasks: [],
  tasksLoading: false,
});

const mutations = {
  setNewTask(state,data){state.newTask = data;},
  setNewTaskLoading(state,data){state.newTaskLoading = data;},
  setPollTasksLoading(state,data){state.pollTasksLoading = data;},
  setTasks(state,data){
    state.tasks = data;
    state.tasksLoading = false;
  },
  setTasksLoading(state,data){state.tasksLoading = data;},
};

const actions = {
  async fetchTasks({commit,dispatch}){
    try{
      commit('setPollTasksLoading',true);
      const {data} = await npAPI.fetchTasks();
      commit('setTasks',data);
      if(data[0].status===202){
        let cont = true;
        let intResults = setInterval(async ()=>{
          if(cont){
            const {data} = await npAPI.fetchTasks();
            commit('setTasks',data);
            if(data[0].status!==202){
              cont = false;
              commit('setPollTasksLoading',false);
            }
          }else{
            clearInterval(intResults);
          }
        },5000);
      }else{
        commit('setPollTasksLoading',false);
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err}, { root: true });
      commit('setPollTasksLoading',false);
    }
  },
  async newTask({commit,dispatch}){
    commit('setNewTaskLoading',true);
    try{
      const res = await npAPI.newTask();
      commit('setNewTask',res);
      commit('setNewTaskLoading',false);
    }catch(err){
      commit('setNewTaskLoading',false);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
};

const getters = {
  getNewTask: (state)=>{
    return state.newTask;
  },
  getTasks: (state)=>{
    return state.tasks.map(e=>{
      return {
        time_started: e.created,
        time_completed: e.completed,
        duration: (e.completed!==null)?(moment(e.completed).diff(moment(e.created))/1000):(moment(new Date).diff(moment(e.created))/1000),
        user: e.created_by,
        status: e.status,
        message: e.reason,
      };
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  